import { Component, Inject, OnInit, computed, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';

export interface DialogData {
	termID: number;
}

enum PricePriority {
	TERM = 'T',
	GROUP = 'G',
	PRODUCT = 'P',
}

@Component({
	selector: 'app-group-offer-active-price-setting-dialog',
	templateUrl: './group-offer-active-price-setting-dialog.component.html',
	styleUrls: ['./group-offer-active-price-setting-dialog.component.scss'],
})
export class GroupOfferActivePriceSettingDialogComponent implements OnInit {
	editable = true;
	disableHTMLClose: boolean;
	buttonnone = true;
	currency: Array<any> = [];
	board: Array<any> = [];
	priceOption: Array<any> = [];
	priceSetting = signal(null);

	termIcon = computed(() => this.priceSetting()?.termSet.length !== 0);
	groupIcon = computed(() => this.priceSetting()?.groupSet.length !== 0);
	productIcon = computed(() => this.priceSetting()?.productSet.length !== 0);

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: DialogData,
		private readonly dialogRef: MatDialogRef<GroupOfferActivePriceSettingDialogComponent>,
		private readonly bag: DataBagService,
	) {}

	ngOnInit(): void {
		this.bag.get('/currency/?limit=999', (result) => {
			this.currency = result.results;
		});
		this.bag.get('/board/?limit=999', (result) => {
			this.board = result.results;
		});
		this.bag.get('/offer/price_option/', (result) => {
			this.priceOption = result.results;
			this.priceOption.map((obj) => {
				if (obj.method == 'C') {
					obj.method = 'PLN';
				} else obj.method = '%';
			});
		});
		this.bag.get('/board/?limit=999', (result) => {
			this.board = result.results;
		});

		this.bag.get(`/offer/term/${this.data.termID}/`, (element) => {
			let activePriceSettingID: number;
			switch (element.pricePriority) {
				case PricePriority.TERM:
					if (element.priceSettings.productPriceSettings !== null) {
						activePriceSettingID = element.priceSettings.productPriceSettings;
					}
					if (element.priceSettings.groupProductPriceSettings !== null) {
						activePriceSettingID = element.priceSettings.groupProductPriceSettings;
					}
					if (element.priceSettings.termPriceSettings !== null) {
						activePriceSettingID = element.priceSettings.termPriceSettings;
					}
					break;
				case PricePriority.GROUP:
					activePriceSettingID = element.priceSettings.groupProductPriceSettings;
					break;
				case PricePriority.PRODUCT:
					activePriceSettingID = element.priceSettings.productPriceSettings;
					break;
				default:
					break;
			}

			this.bag.get(`/offer/price_setting/${activePriceSettingID}/`, (result) => {
				this.priceSetting.set(result);
			});
		});
	}

	getPriceSettingId(priceSettingId): void {
		this.dialogRef.close(priceSettingId);
	}
}
